export default __webpack_public_path__ + "static/media/Plateau_Hurghada.00d30ba8.jpg";